module.exports = "::ng-deep .col.image {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n  ::ng-deep .col.image img {\n    height: 13em;\n    margin-bottom: 1em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/services-bd/services-bd.component.scss
// module id = ./src/app/components/services-bd/services-bd.component.scss
// module chunks = main